import { EdgeRemoveChannelMemberRepository } from '@/modules/connect/infra'
import type { RemoveChannelMember } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeRemoveChannelMember(): RemoveChannelMember {
  return new EdgeRemoveChannelMemberRepository(makeSupabaseEdgeHttpClient()).execute
}
